<div class="custom-modal">
  <form [formGroup]="atualizacaoContatoPessoaForm" #formElement>

    <!-- Campo de Seleção -->
    <div class="row g-2">
      <div class="col-12">
        <label for="vinculoIds" class="form-label fw-bold">Vinculos:</label>
        <nz-select
          formControlName="vinculoIds"
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Selecionar pessoas"
          nzSize="large"
          (ngModelChange)="onSelectChange($event)"
          [compareWith]="compareFn"
          [nzMaxTagCount]="3"
          class="custom-select"
        >
          <!-- Opção para Selecionar Todos -->
          <nz-option
            [nzValue]="'selectAll'"
            [nzLabel]="allSelected ? 'Desmarcar Todos' : 'Selecionar Todos'"
          >
          </nz-option>
          <!-- Lista de opções -->
          <nz-option
            *ngFor="let item of vinculos"
            [nzValue]="item?.id"
            [nzLabel]="buildLabel(item)"
          >
          </nz-option>
        </nz-select>
      </div>
    </div>
  </form>

  <!-- Botões de Ação -->
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="primary" class="me-2" (click)="editarContatos()">Editar Contatos</button>
      <button nz-button nzType="default" (click)="handleCancel()">Cancelar</button>
    </div>
  </div>
</div>
